export default __webpack_public_path__ + "static/media/circleClock-default.e92b8cc7.png";